import React, { Component } from 'react';
import { apiServices } from '../services/apiServices';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable, { defaultSorted } from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import filterFactory, { multiSelectFilter  } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import moment from 'moment';
import Loader from './../components/loaders/loader';
import ReactGA from 'react-ga';
import {Form} from 'react-bootstrap';

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

let qualityFilter;

class Analytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: '',
            toDate: '',
            tableData: [],
            isDataFetched: false,
            types: 'SERVICES',
            isLoading: false,
            multiSelect: [],
            questionsColumn:'',
        }
    }

    initialState = () => {
        return {
            fromDate: '',
            toDate: '',
            types: 'SERVICES',
        };
    }

    componentDidMount() {
        this.getAnalyticsData();
        // console.log(window.location);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    selectMultiple = (e,num) => {
        if(e.target.checked){
            this.setState(prevState=>{
            let multiSelect = prevState.multiSelect;
            multiSelect.push(num);
            return {multiSelect}
        }, () => {
            qualityFilter(this.state.multiSelect); 
            //console.log(this.state.multiSelect) 
        });
        }else{
            this.setState(prevState=>{
            let multiSelect = prevState.multiSelect;
            multiSelect = multiSelect.filter(multi=> multi!==num )
            return {multiSelect}
        }, () => {
            qualityFilter(this.state.multiSelect); 
            // console.log(this.state.multiSelect) 
        });
        }
    }

    getAnalyticsData = async () => {
        // console.log(apiServices.loadAnalysisData);
        this.setState({ isLoading: true });
        let oCoummunity = JSON.parse(localStorage.getItem('community')).community,
            sUUID = oCoummunity.uuid,
            oRequest = {
                uuid: sUUID,
                activeYN: 'Y',
                deleteYN: 'N',
                statusList: ["9", "10", "11", "12", "33", "34"],
                caseSetAttrFlag: true
            };

        if (this.state.types === "SURVEY") {
            oRequest.types = [this.state.types];
        }
        if (this.state.types === "SERVICES") {
            oRequest.types = ["ALERT"];
        }
        // console.log("oRequest ",oRequest);

        let response = await apiServices.loadAnalysisData(oRequest);
        this.computeTableData(response);
    }

    computeTableData = (p_response) => {
        // console.log(p_response);
        let i, aTableData = [],
            aServices = p_response.caseSetTO_Attributes_analysis,
            nLen = aServices.length, answers=[],questionsColumn=[];
        if (this.state.fromDate !== '' && this.state.toDate !== '') {
            let fromDate = new Date(this.state.fromDate).getTime();
            let toDate = new Date(this.state.toDate).getTime();
            // console.log("fromDate ", fromDate);
            // console.log("toDate ", toDate);
            for (i = 0; i < nLen; i++) {
                // console.log("comparing dates ",aServices[i]);
                let createdAt = aServices[i].createdAt;
                // console.log("createdAt ", createdAt);
                if (createdAt >= fromDate && createdAt <= toDate) {
                    let status = "";
                    if(aServices[i].status===9){
                        status = 'Open'; 
                    }
                    if(aServices[i].status===10){
                        status = 'Approved'; 
                    }
                    if(aServices[i].status===11){
                        status = 'Declined'; 
                    }
                    if(aServices[i].status===12){
                        status = 'Resolved'; 
                    }
                    let aTemp = {
                        'id': aServices[i].id,
                        'createdAt': moment(aServices[i].createdAt).format('DD-MM-YYYY'),
                        'name': aServices[i].communityPreferencesByCaseType.name,
                        'country': aServices[i].country,
                        'status' : status
                    };

                    // console.log("aServices[i] else ",aServices[i].caseExtensions);
                    if(aServices[i].caseExtensions!==null){
                        answers = aServices[i].caseExtensions.filter(chatData => !chatData.hasOwnProperty('social'));
                    answers = JSON.parse(answers[0].jsonValue);
                    // console.log("answers",answers);
                    if(answers!==null){
                        for (const key of Object.keys(answers)) {
                            if(key!=='qInfo'){
                                let q= key;
                                // console.log("q",q);
                                aTemp[key] = answers[key];
                                questionsColumn.push(q);
                            }
                        }
                    }
                    }
                    // console.log(aTemp);
                    aTableData.push(aTemp);
                }
            }
        } else {
            for (i = 0; i < nLen; i++) {
                let status = "";
                if(aServices[i].status===9){
                    status = 'Open'; 
                }
                if(aServices[i].status===10){
                    status = 'Approved'; 
                }
                if(aServices[i].status===11){
                    status = 'Declined'; 
                }
                if(aServices[i].status===12){
                    status = 'Resolved'; 
                }
                let aTemp = {
                    'id': aServices[i].id,
                    'createdAt': moment(aServices[i].createdAt).format('DD-MM-YYYY'),
                    'name': aServices[i].communityPreferencesByCaseType.name,
                    'country': aServices[i].country,
                    'status' : status
                };

                // console.log("aServices[i] else ",aServices[i].caseExtensions);
                if(aServices[i].caseExtensions!==null){
                    answers = aServices[i].caseExtensions.filter(chatData => !chatData.hasOwnProperty('social'));
                answers = JSON.parse(answers[0].jsonValue);
                // console.log("answers",answers);
                if(answers!==null){
                    for (const key of Object.keys(answers)) {
                        if(key!=='qInfo'){
                            let q= key;
                            // console.log("q",q);
                            aTemp[key] = answers[key];
                            questionsColumn.push(q);
                        }
                    }
                }
                }
                // console.log(aTemp);
                aTableData.push(aTemp);
            }
        }
        // console.log(aTableData)
        if (this.state.types === "SURVEY") {
            this.setState({ tableData: aTableData, questionsColumn, isDataFetched: true, isLoading: false});
        }else{
            this.setState({ tableData: aTableData, questionsColumn, isDataFetched: true, isLoading: false});
        }
    }


    handleFilterSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // let { fromDate, toDate, types } = this.state;
        // console.log(fromDate, toDate, types);
        this.getAnalyticsData();
    }

    handleFilterReset = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let oInitialState = this.initialState();
        this.setState(oInitialState, () => this.getAnalyticsData());
    }

    handleChangeEvent = (e) => {
        let { name, value } = e.target;
        // console.log(name,value);
        this.setState({
            [name]: value
        });
    }

    render() {


        
        const columns = [{
            dataField: 'id',
            text: 'ID',
            sort: true,
            // headerStyle: () => {
            //     return { width: "350px" };
            // }
        }, {
            dataField: 'createdAt',
            text: 'Created Date',
            sort: true
        }, {
            dataField: 'name',
            text: 'Name',
            sort: true
        }, {
            dataField: 'country',
            text: 'Country',
            sort: true
        }];

        const selectOptions = {
            'Open': 'Open',
            'Approved': 'Approved',
            'Declined': 'Declined',
            'Resolved': 'Resolved',
        };

        let filterColumn = {
            dataField: 'status',
            text: 'Status',
            filter: multiSelectFilter({
                options: selectOptions,
                getFilter: (filter) => {
                    // qualityFilter was assigned once the component has been mounted.
                    qualityFilter = filter;
                }
            })
        }
        columns.push(filterColumn)

        let questionsColumn = [];
        // console.log("questionsColumn",this.state.questionsColumn);
        if(this.state.questionsColumn.length>0){
            let newSet = new Set(this.state.questionsColumn)
            questionsColumn = [...newSet]
            questionsColumn.forEach(question=>{
                    columns.push({
                        dataField:question,
                        text:question
                    });
            })
            // console.log("columns",columns);
        }

        


        let noDataText = "Loading...";
        if (this.state.isDataFetched) {
            noDataText = "No Data Found";
        }

        const sizePerPageOptionRenderer = ({
            text,
            page,
            onSizePerPageChange
        }) => (
            <li
                key={ text }
                role="presentation"
                className="dropdown-item"
            >
            { // eslint-disable-next-line
                <a href="javascript:void(0)" 
                    tabIndex="-1"
                    role="menuitem"
                    data-page={ page }
                    onMouseDown={ (e) => {
                        e.preventDefault();
                        onSizePerPageChange(page);
                    } }
                >
                    { text }
                </a>
            }
            </li>
        );

        const paginationOption = {
            page: 1, // which page you want to show as default
            sizePerPageList: [{
                text: '5',
                value: 5
            }, {
                text: '10',
                value: 10
            }, {
                text: 'All',
                value: this.state.tableData.length
            }], // you can change the dropdown list for size per page
            sizePerPage: 5, // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3, // the pagination bar size.
            prePageText: 'Prev', // Previous page button text
            nextPageText: 'Next', // Next page button text
            firstPageText: 'First', // First page button text
            lastPageText: 'Last', // Last page button text
            showTotal: true,
            sizePerPageOptionRenderer
        };

        const date = moment(new Date()).format('MMMM Do YYYY, h:mm:ss a');

        return (
            <div className='container-fluid my-4 analytics_page'>
                <Loader isLoading={this.state.isLoading}/>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <i className="fa fa-filter"></i>
                                <strong>Filters</strong>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset}>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6">
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                       <span className="input-group-text">From Date</span>
                                                    </div>
                                                    <input className="form-control" id="analysis_from_date" 
                                                        type="date" name="fromDate"
                                                        value={this.state.fromDate} 
                                                        onChange={this.handleChangeEvent}
                                                    />
                                                    <div className="input-group-append">
                                                       <span className="input-group-text">
                                                       <i className="fa fa-calendar"></i>
                                                       </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                       <span className="input-group-text">To Date</span>
                                                    </div>
                                                    <input className="form-control" id="analysis_to_date" 
                                                        type="date" name="toDate" 
                                                        value={this.state.toDate}
                                                        onChange={this.handleChangeEvent}
                                                    />
                                                    <div className="input-group-append">
                                                       <span className="input-group-text">
                                                       <i className="fa fa-calendar"></i>
                                                       </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="types" id="services" value="SERVICES" checked={this.state.types==="SERVICES"} onChange={this.handleChangeEvent}/>
                                                <label className="form-check-label" htmlFor="services">Services</label>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                              <input className="form-check-input" type="radio" name="types" id="survey" value="SURVEY" checked={this.state.types==="SURVEY"} onChange={this.handleChangeEvent} />
                                              <label className="form-check-label" htmlFor="survey">Survey</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group form-actions pt-3">
                                        <button className="btn btn-primary" type="submit">Filter</button>
                                        <button className="btn btn-danger mx-3" type="reset">Clear</button>
                                    </div>
                               </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <main className="card">
                            <div className="card-header">
                                <i className="fa fa-table"></i>
                                <strong>Analysis</strong>
                            </div>
                            <div className="card-body table_react_bootstrap responsive_table">
                              {/*  <DataTable 
                                    columns={this.state.tableCols}
                                    rows={this.state.tableData}
                                />*/}
                                <ToolkitProvider
                                  keyField="id"
                                  data={ this.state.tableData }
                                  columns={ columns }
                                  exportCSV={ { fileName: `Analysis (${date}).csv`, onlyExportFiltered: true, exportAll: false } }
                                  search
                                >
                                {
                                    props => (
                                        <div>
                                            <ExportCSVButton { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                                            <SearchBar { ...props.searchProps } />
                                            <div className="py-3 text-center">
                                                <Form>
                                                    {['checkbox'].map(type => (
                                                        <div key={`custom-inline-${type}`}>
                                                            <Form.Check
                                                                custom
                                                                inline
                                                                label="Open"
                                                                type={type}
                                                                id={`custom-inline-${type}-1`}
                                                                onChange={(e)=>this.selectMultiple(e,'Open')}
                                                            />
                                                            <Form.Check
                                                                custom
                                                                inline
                                                                label="Approved"
                                                                type={type}
                                                                id={`custom-inline-${type}-2`}
                                                                onChange={(e)=>this.selectMultiple(e,'Approved')}
                                                            />
                                                            <Form.Check
                                                                custom
                                                                inline
                                                                label="Resolved"
                                                                type={type}
                                                                id={`custom-inline-${type}-3`}
                                                                onChange={(e)=>this.selectMultiple(e,'Resolved')}
                                                            />
                                                            <Form.Check
                                                                custom
                                                                inline
                                                                label="Declined"
                                                                type={type}
                                                                id={`custom-inline-${type}-4`}
                                                                onChange={(e)=>this.selectMultiple(e,'Declined')}
                                                            />
                                                        </div>
                                                    ))}
                                                </Form>
                                            </div>
                                            <BootstrapTable 
                                                { ...props.baseProps }
                                                bootstrap4 
                                                noDataIndication = { noDataText }
                                                pagination = { paginationFactory(paginationOption) }
                                                striped 
                                                hover
                                                defaultSorted={ defaultSorted }
                                                filter={ filterFactory() }
                                            />
                                        </div>
                                    )
                                }
                                </ToolkitProvider>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        );
    }
}

export default Analytics;